import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { FacilityService } from '../../servicies/facility.service';
import { InsuranceInfoResponseModel } from 'src/app/shared/models/response/insurance-info-response-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { Result } from 'src/app/shared/models/response/result';

@Component({
  selector: 'app-add-insurance-dialog',
  templateUrl: './add-insurance-dialog.component.html',
  styleUrls: ['./add-insurance-dialog.component.sass'],
  standalone: false
})
export class AddInsuranceDialogComponent extends BaseComponent {
  form: FormGroup;

  constructor(
    messageService: MessageService,
    private fb: FormBuilder,
    public dialogRef: DynamicDialogRef,
    private facilityService: FacilityService,
    private webStorageService: WebStorageService
  ) {
    super(messageService);
    this.form = this.fb.group({
      crmPolicyHolderName: ['', [Validators.required]]
    });
  }

  onSearch(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const insuranceModel = this.form.value;
    insuranceModel.modifiedByUserInfoId = this.webStorageService.getCurrentUserToken().userId;

    this.facilityService.AddInsurance(insuranceModel).subscribe({
      next: (result: Result) => {
        if (result?.isSuccess) {
          this.showSuccessMessage('Insurance is created successfully.');
          this.dialogRef.close(true);
        } else {
          this.showErrorMessage(result.message);
        }
      },
      error: (error) => {
        this.showErrorMessage(error.message);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
